import { createAction, props } from '@ngrx/store';
import { BackgroundProgress } from 'core/http/project/background/background-task.service';

export const saveReadyProgress = createAction('[Ready Progress Store] Save Ready Progress',
  props<{ progress: BackgroundProgress }>());
